<template>
  <div class="select-course-assistant-recommend">
    <div class="select-course-assistant-recommend-course">
      <div class="select-course-assistant-recommend-course-header">
        <span></span> 推荐课程
      </div>
      <ym-img class="select-course-assistant-recommend-course-image"
              :src="src"
              @click="handleClickDetailBtn"
      />
    </div>
    <div class="select-course-assistant-recommend-answer">
      <div class="select-course-assistant-recommend-answer-header">
        <span></span> 推荐理由
      </div>
      <div class="select-course-assistant-recommend-answer-content">
        {{ answer }}
      </div>
    </div>
    <div class="select-course-assistant-recommend-btn"
         @click="handleClickDetailBtn"
    >
      查看推荐课程
    </div>
  </div>
</template>

<script>
  import { locationHref } from '@/utils';
  import { getStaticShareInfo } from '@/services/app';

  export default {
    name: 'SelectCourseAssistantRecommend',
    metaInfo: {
      title: '',
    },
    computed: {
      answer() {
        return this.$route.query.answer;
      },
      path() {
        return this.$route.query.path;
      },
      id() {
        return parseInt(this.$route.query.id, 10);
      },
      src() {
        // eslint-disable-next-line global-require,import/no-dynamic-require
        return require(`@/assets/img/select_course_assistant/${this.id}.png`);
      },
    },
    methods: {
      handleClickDetailBtn() {
        locationHref(this.path);
      },
      async getStaticShareInfo() {
        await getStaticShareInfo({
          type: 'selectCourseAssistant',
        });
      },
    },
    created() {
      this.getStaticShareInfo();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .select-course-assistant-recommend {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: 100px;
    background: @color-white;

    &-course {
      padding-top: @size-extra-medium;
      margin-bottom: 80px;
    }

    &-course-image {
      width: 92%;
      margin-left: 4%;
    }

    &-course-header,
    &-answer-header {
      display: flex;
      align-items: center;
      margin-bottom: @size-base;
      padding-left: @size-base;
      color: @color-text-base;
      font-size: @font-size-extra-extra-large;
      font-weight: @font-weight-bold;
      line-height: 1;

      span {
        display: block;
        width: 8px;
        height: 44px;
        margin-right: 16px;
        content: '';
        background: @color-primary;
        border-radius: 4px;
      }
    }
    &-answer-content {
      width: 100%;
      padding: 0 30px;
      box-sizing: border-box;
      color: @color-text-base;
      font-size: @font-size-base;
      line-height: 1.5;
    }

    &-btn {
      width: 424px;
      height: 88px;
      margin: 100px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-white;
      font-size: 34px;
      font-weight: @font-weight-bold;
      background: @color-primary;
      border-radius: 44px;
    }
  }
</style>
